import type { TFunction } from 'i18next';
import { z } from 'zod';
import {
  PlaceholderStatus,
  PlaceholderType,
  type GetPlaceholderSubcategoryResponse,
} from '@/api/generated/schemas';

/**
 * Factory Zod schématu formuláře subkategorie placeholderu. Lokalizované hlášky se vkládají přímo
 * do schématu (single source of truth), proto se staví z `t` až za běhu. Subkategorie je jednoduchá
 * položka: název, kód, stav a vazba na hlavní typ placeholderu.
 */
export function buildSubcategoryFormSchema(t: TFunction) {
  return z.object({
    type: z.enum([
      PlaceholderType.Accommodation,
      PlaceholderType.Transport,
      PlaceholderType.Activities,
      PlaceholderType.LocalGuides,
      PlaceholderType.OtherServices,
    ]),
    name: z.string().trim().min(1, t('schemes.subcategoryForm.validation.nameRequired')),
    code: z.string(),
    status: z.enum([PlaceholderStatus.Active, PlaceholderStatus.Archived]),
  });
}

export type SubcategoryFormValues = z.infer<ReturnType<typeof buildSubcategoryFormSchema>>;

/** Prázdné výchozí hodnoty pro režim zakládání. */
export function emptySubcategoryFormValues(): SubcategoryFormValues {
  return {
    type: PlaceholderType.Accommodation,
    name: '',
    code: '',
    status: PlaceholderStatus.Active,
  };
}

/** Mapuje detail subkategorie z API na hodnoty formuláře (režim editace). */
export function fromGetSubcategoryResponse(
  response: GetPlaceholderSubcategoryResponse
): SubcategoryFormValues {
  return {
    type: response.type,
    name: response.name,
    code: response.code ?? '',
    status: response.status,
  };
}
